<template>
  <div
    class="basket-cheering-message flex w-fit items-center gap-2 rounded-sm bg-platin px-3 py-2 text-sm sm:text-base"
    data-qa="basket-cheering-message"
  >
    <IconStopwatch class="size-4 shrink-0" />
    <span>
      <span class="font-[700]">{{ $t('basket.cheering_message_bold') }}</span>
      <span class="font-normal">{{
        $t('basket.cheering_message_normal')
      }}</span>
    </span>
  </div>
</template>
